module.exports = __webpack_public_path__ + "img/partners.766ff9bd.png";